export enum AssignmentTrigger {
  defaultTrigger = 'default-trigger',
  agentCreation = 'agent-creation',
}
